import { forwardRef, type Ref, type SVGProps } from "react";
const IconMinusOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M26 17H6a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2" /></svg>;
const ForwardRef = forwardRef(IconMinusOutlineSVG);
ForwardRef.displayName = "IconMinusOutline";
export { ForwardRef as IconMinusOutline };